// Google Analytics 4 — chargement piloté par REACT_APP_GA4_ID (no-op si absent)
const GA_ID = process.env.REACT_APP_GA4_ID;
let loaded = false;

export const initGA4 = () => {
  if (!GA_ID || loaded || typeof window === "undefined") return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);
};

export const trackEvent = (name, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
};

export const ga4Enabled = () => !!GA_ID;
